<template>
  <v-app>
    <notifications />
    <!-- <core-filter /> -->
    <core-home-toolbar
      v-if="
        $route.name !== 'Login' &&
        $route.meta.isFrontend === true &&
        $route.name !== 'EntityLink' &&
        $route.name !== 'EntityLinkHighlightedCard' &&
        $route.name !== 'ProspectingBuyers'
      "
    />
    <!-- <core-toolbar
      v-if="$route.name !== 'Login' && $route.meta.isFrontend !== true"
    /> -->

    <core-drawer
      v-if="$route.name !== 'Login' && $route.meta.isFrontend !== true"
    />

    <core-view style="position: relative; margin-top: 20px" />
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
window.numberComparator = function numberComparator(valueA, valueB) {
  valueA = valueA == "" ? 0 : valueA;
  valueB = valueB == "" ? 0 : valueB;
  return parseInt(valueA) - parseInt(valueB);
};
window.moneyComparator = function moneyComparator(valueA, valueB) {
  if (valueA != "" && valueB != "") {
    return parseFloat(valueA) - parseFloat(valueB);
  } else if (valueA == "" && valueB != "") {
    return -1;
  } else if (valueA != "" && valueB == "") {
    return 1;
  } else {
    return 1;
  }
};
window.formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
});
export default {
  watch: {
    $route(value) {
      if (value.name) {
        this.checkSupplierRoutes();
      }
    },
  },
  computed: {
    ...mapGetters({
      descriptionContent: "vueMeta/descriptionContent",
      titleContent: "vueMeta/titleContent",
      titleTag: "vueMeta/titleTag",
    }),
  },

  created() {
    if (this.$route.name) {
      this.checkSupplierRoutes();
    }
  },
  metaInfo() {
    let content = this.descriptionContent;
    return {
      title: this.titleTag,
      meta: [
        {
          vmid: "description",
          name: "description",
          content: content,
        },
        {
          vmid: "keywords",
          name: "keywords",
          content: "Business, Commercial, Consumer, Charity",
        },
        {
          vmid: "title",
          name: "title",
          content: this.titleContent,
        },
      ],
    };
  },
  methods: {
    checkSupplierRoutes() {
      if (
        this.$route.name.startsWith("BusinessProfile") ||
        this.$route.name.startsWith("SearchResults")
      ) {
        if (this.$route.name.startsWith("SearchResults")) {
          let descriptionMeta = "";
          let title = "";
          descriptionMeta = `Search Results - Upstream are 100% Charitable and dedicated to improving the well-being of children and youth in New Zealand. Use our approved suppliers and help us provide support and community work for our youth`;
          title = `Search Results- Upstream 100% Charitable`;
          this.$store.commit("vueMeta/setMetaData", {
            metaDescription: descriptionMeta,
            metaTitle: title,
            titleTag: title,
          });
        }
      } else {
        let descriptionMeta = `${this.routeNameFormat(
          this.$route.name
        )} - Upstream are 100% Charitable and dedicated to improving the well-being of children and youth in New Zealand. Use our approved suppliers and help us provide support and community work for our youth`;
        let title = `${this.routeNameFormat(
          this.$route.name
        )} - Upstream 100% Charitable`;
        this.$store.commit("vueMeta/setMetaData", {
          metaDescription: descriptionMeta,
          metaTitle: title,
          titleTag: title,
        });
      }
    },
    routeNameFormat(routeName) {
      switch (routeName) {
        case "AboutUpstream":
          return "About Upstream";
        case "About":
          return "Impact Areas";
        case "GoodCausePublic":
          return "Good Causes";
        case "GoodCauseProfile":
          return "Good Causes";
        case "ImpactBusiness":
          return "Impact Buyers";
        case "ImpactBusinessProfileKeyword":
          return "Impact Buyers";
        default:
          return routeName;
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/index.scss";

/* Remove in 1.2 */
.v-datatable thead th.column.sortable i {
  vertical-align: unset;
}
</style>
<style>
@font-face {
  font-family: Gotham;
  font-weight: 100;
  src: url("https://upstreamnz.s3.ap-southeast-2.amazonaws.com/fonts/Gotham+Thin.otf")
    format("opentype");
}

@font-face {
  font-family: Gotham;
  font-weight: 200;
  src: url("https://upstreamnz.s3.ap-southeast-2.amazonaws.com/fonts/Gotham+Extra+Light.otf")
    format("opentype");
}

@font-face {
  font-family: Gotham;
  font-weight: 300;
  src: url("https://upstreamnz.s3.ap-southeast-2.amazonaws.com/fonts/Gotham+Light.otf")
    format("opentype");
}

@font-face {
  font-family: Gotham;
  font-weight: 400;
  src: url("https://upstreamnz.s3.ap-southeast-2.amazonaws.com/fonts/Gotham+Regular.otf")
    format("opentype");
}

@font-face {
  font-family: Gotham;
  font-weight: 500;
  src: url("https://upstreamnz.s3.ap-southeast-2.amazonaws.com/fonts/Gotham+Medium.otf")
    format("opentype");
}

@font-face {
  font-family: Gotham;
  font-weight: 600;
  src: url("https://upstreamnz.s3.ap-southeast-2.amazonaws.com/fonts/Gotham+Book.otf")
    format("opentype");
}

@font-face {
  font-family: Gotham;
  font-weight: bold;
  src: url("https://upstreamnz.s3.ap-southeast-2.amazonaws.com/fonts/Gotham+Bold.otf")
    format("opentype");
}

@font-face {
  font-family: Gotham;
  font-weight: 800;
  src: url("https://upstreamnz.s3.ap-southeast-2.amazonaws.com/fonts/Gotham+Ultra.otf")
    format("opentype");
}

@font-face {
  font-family: Gotham;
  font-weight: 900;
  src: url("https://upstreamnz.s3.ap-southeast-2.amazonaws.com/fonts/Gotham+Black.otf")
    format("opentype");
}

.imageBlueOverlay {
  height: 100%;
  width: 100%;
  background: #4cc7e8;
  opacity: 30%;
  transition: opacity 0.3s;
  transition-timing-function: ease-in-out;
}
.imageBlueOverlay:hover {
  height: 100%;
  width: 100%;
  background: #4cc7e8;
  opacity: 0%;
}
.imageGreyOverlay {
  height: 100%;
  width: 100%;
  background: grey;
  opacity: 60%;
  transition: opacity 0.3s;
  transition-timing-function: ease-in-out;
}
.imageGreyOverlay:hover {
  height: 100%;
  width: 100%;
  background: grey;
  opacity: 0%;
}
.grayscaleHoverOptions {
  filter: grayscale(100%);
  transition: filter 0.3s;
  transition-timing-function: ease-in-out;
}
.grayscaleHoverOptions:hover {
  filter: grayscale(0%);
}

h1,
h2,
h3,
.heading {
  font-family: Gotham !important;
  font-weight: bold !important;
}

h1,
.heading {
  font-size: 3rem !important;
}

@media screen and (max-width: 600px) {
  h1,
  .heading {
    font-size: 2rem !important;
  }
}
</style>
